import { useEffect } from "react";
import { BRAND } from "@/lib/content";

export default function Seo({ title, description, image, path = "", schema }) {
  useEffect(() => {
    const fullTitle = title ? `${title} | ${BRAND.name} DC` : `${BRAND.name} | ${BRAND.tagline}`;
    document.title = fullTitle;

    const set = (attr, key, val) => {
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", val);
    };

    const url = `${window.location.origin}${path}`;
    const desc = description || `${BRAND.name} — ${BRAND.tagline}. Premium hookah, craft cocktails, VIP bottle service and nightlife on U Street, Washington DC.`;
    const img = image || "https://customer-assets-jai6qajn.emergentagent.net/job_luxury-lounge-dc-1/artifacts/139svwi6_IMG_1760.jpeg";

    set("name", "description", desc);
    set("property", "og:title", fullTitle);
    set("property", "og:description", desc);
    set("property", "og:image", img);
    set("property", "og:url", url);
    set("property", "og:type", "website");
    set("name", "twitter:card", "summary_large_image");
    set("name", "twitter:title", fullTitle);
    set("name", "twitter:description", desc);
    set("name", "twitter:image", img);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);

    const schemaData = schema || {
      "@context": "https://schema.org",
      "@type": "NightClub",
      name: `${BRAND.name} DC`,
      description: desc,
      address: {
        "@type": "PostalAddress",
        streetAddress: "1214 U St NW",
        addressLocality: "Washington",
        addressRegion: "DC",
        postalCode: "20009",
        addressCountry: "US",
      },
      telephone: BRAND.phone,
      url,
      image: img,
      servesCuisine: ["Cocktails", "Hookah", "American"],
      priceRange: "$$",
      aggregateRating: { "@type": "AggregateRating", ratingValue: "4.5", reviewCount: "180" },
    };
    let ld = document.getElementById("ld-json");
    if (!ld) {
      ld = document.createElement("script");
      ld.type = "application/ld+json";
      ld.id = "ld-json";
      document.head.appendChild(ld);
    }
    ld.textContent = JSON.stringify(schemaData);
  }, [title, description, image, path, schema]);

  return null;
}
